import React from "react";
import Currency from "react-currency-formatter";

const MexicanCurrency = ({ quantity }) => (
  <Currency quantity={quantity} symbol="$" locale="en" />
);

export default MexicanCurrency;
